// extracted by mini-css-extract-plugin
export default {"textColumnWrapper":"TransactionDetailContent_textColumnWrapper__WbxsY"};